import React from "react";
import { Popconfirm } from "antd";

interface ConfirmPopProps {
    onOk: Function
    onCancel?: Function
    title?: string
    children: any
}

const ConfirmPop = (
    props: ConfirmPopProps
) => {
    const [visible, setVisible] = React.useState(false);
    const [confirmLoading, setConfirmLoading] = React.useState(false);

    const {
        onOk,
        onCancel,
        title = '',
        children
    } = props

    const showPopconfirm = () => {
        setVisible(true);
    };

    const handleOk = async () => {
        setConfirmLoading(true);
        try{
            await onOk()
        }catch(e){}
        setVisible(false);
        setConfirmLoading(false);
    };

    const handleCancel = () => {
        onCancel && onCancel()
        setVisible(false);
    };

    return (
        <>
            <Popconfirm
                title={title}
                placement="topRight"
                visible={visible}
                onConfirm={handleOk}
                okButtonProps={{ loading: confirmLoading }}
                onCancel={handleCancel}
            >
                <span onClick={showPopconfirm}>
                    {children}
                </span>
            </Popconfirm>
        </>
    );
};
export { ConfirmPop };
